import React from 'react';
//import {Paper, IconButton, Popover, Typography, Button} from '@material-ui/core';
import { IconButton, Grid, Popover, Typography, Select, InputLabel, MenuItem, FormHelperText } from '@material-ui/core';
import '../App.css';
import { FiHelpCircle } from "react-icons/fi";
import { useStyles } from '../Components/useStyles';

export default function ApplicationPage({program, firstChoice, secondChoice, thirdChoice, setFirChoice, setSecondChoice, setThirdChoice, siblingDOB}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    function openHelp(event) {
        setAnchorEl(event.currentTarget);
    }
    function closeHelp() {
        setAnchorEl(null);
    }

    function SelectionBasedOnProgram() {
        if(program === 'EFI'){
            return (
                <>
                <p className="addSpaceTop"> </p>
                <p className='details'>
                    You first choice must be your EFI or LFI catchment school. <br/><br/>
                    Please visit{' '} <a href="https://mybaragar.com/index.cfm?event=page.SchoolLocatorPublic&DistrictCode=BC38" target="_blank"> https://mybaragar.com/</a>{' '}
                    to find your EFI or LFI catchment school.
                </p>
                <p className='addSpaceBottom'> </p>
                <Grid container spacing={3}>
                    <Grid item xs>
                        <InputLabel required htmlFor="efi-helper">EFI {siblingDOB !== null && siblingDOB !== '' ? 'Sibling' :  'Catchment' } School</InputLabel>
                        <Select
                            value={firstChoice}
                            //value={'Anderson'}
                            className={classes.FulltextField}
                            onChange={event=>setFirChoice(event.target.value)}
                            //disabled={true}
                        >
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Anderson'}>{'Anderson'}</MenuItem> 
                            <MenuItem value={'Bridge'}>{'Bridge'}</MenuItem>     
                            <MenuItem value={'Dixon'}>{'Dixon'}</MenuItem>        
                            <MenuItem value={'Gilmore'}>{'Gilmore'}</MenuItem>  
                            <MenuItem value={'Homma'}>{'Homma'}</MenuItem>  
                            <MenuItem value={'Mitchell'}>{'Mitchell'}</MenuItem> 
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>  
                        </Select>
                        <FormHelperText>{siblingDOB !== null && siblingDOB !== '' ? 'The school sibling is attending' :  'Select based on your catchment' }</FormHelperText>
                    </Grid>
                    <Grid item xs>
                        <InputLabel htmlFor="efi-helper">Second Choice</InputLabel>
                        <Select
                            value={secondChoice}
                            className={classes.FulltextField}
                            onChange={event=>setSecondChoice(event.target.value)}
                        >
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Anderson'}>{'Anderson'}</MenuItem> 
                            <MenuItem value={'Bridge'}>{'Bridge'}</MenuItem>     
                            <MenuItem value={'Dixon'}>{'Dixon'}</MenuItem>        
                            <MenuItem value={'Gilmore'}>{'Gilmore'}</MenuItem>  
                            <MenuItem value={'Homma'}>{'Homma'}</MenuItem>  
                            <MenuItem value={'Mitchell'}>{'Mitchell'}</MenuItem> 
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>        
                        </Select>
                    </Grid>
                    <Grid item xs>
                        <InputLabel htmlFor="efi-helper">Third Choice</InputLabel>
                        <Select
                            value={thirdChoice}
                            className={classes.FulltextField}
                            onChange={event=>setThirdChoice(event.target.value)}
                        >
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Anderson'}>{'Anderson'}</MenuItem> 
                            <MenuItem value={'Bridge'}>{'Bridge'}</MenuItem>     
                            <MenuItem value={'Dixon'}>{'Dixon'}</MenuItem>        
                            <MenuItem value={'Gilmore'}>{'Gilmore'}</MenuItem>  
                            <MenuItem value={'Homma'}>{'Homma'}</MenuItem>  
                            <MenuItem value={'Mitchell'}>{'Mitchell'}</MenuItem> 
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>         
                        </Select>
                    </Grid>
                </Grid>
                    
                </>
            );           
        }
        else if(program === 'LFI'){
            return (
                <>
                <p className='addSpaceTop'> </p>
                <p className='details'>
                    You first choice must be your EFI or LFI catchment school. <br/><br/>
                    Please visit{' '} <a href="https://mybaragar.com/index.cfm?event=page.SchoolLocatorPublic&DistrictCode=BC38" target="_blank"> https://mybaragar.com/</a>{' '}
                    to find your EFI or LFI catchment school.
                </p>
                <p className='addSpaceBottom'> </p>
                <Grid container spacing={3}>
                    <Grid item xs>
                    <InputLabel required htmlFor="efi-helper">LFI {siblingDOB !== null && siblingDOB !== '' ? 'Sibling' :  'Catchment' } School</InputLabel>
                        <Select
                            value={firstChoice}
                            className={classes.FulltextField}
                            onChange={event=>setFirChoice(event.target.value)}
                        >       
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Diefenbaker'}>{'Diefenbaker'}</MenuItem>  
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>  
                        </Select>
                        <FormHelperText>{siblingDOB !== null && siblingDOB !== '' ? 'The school sibling is attending' :  'Select based on your catchment' }</FormHelperText>
                    </Grid>
                    <Grid item xs>
                        <InputLabel htmlFor="efi-helper">Second Choice</InputLabel>
                        <Select
                            value={secondChoice}
                            className={classes.FulltextField}  
                            onChange={event=>setSecondChoice(event.target.value)}          
                        >       
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Diefenbaker'}>{'Diefenbaker'}</MenuItem>  
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>    
                        </Select>
                    </Grid>
   {/*                  <Grid item xs>
                        <InputLabel htmlFor="efi-helper">Third Choice</InputLabel>
                        <Select
                            value={thirdChoice}
                            className={classes.FulltextField}
                            onChange={event=>setThirdChoice(event.target.value)}
                        >       
                            <MenuItem value={'Diefenbaker'}>{'Diefenbaker'}</MenuItem>  
                            <MenuItem value={'Whiteside'}>{'Whiteside'}</MenuItem>     
                        </Select>
                    </Grid> */}
                </Grid>
                <InputLabel htmlFor="lfi-helper"></InputLabel>
                
                </>
            );           
        }
        else{
            return(
                <>
                <Grid container spacing={3}>
                    <Grid item xs>
                        <InputLabel required htmlFor="mont-helper">{siblingDOB !== null && siblingDOB !== '' ? 'Montessori Sibling School' :  'First Choice' }</InputLabel>
                        <Select
                            value={firstChoice}
                            className={classes.FulltextField}
                            onChange={event=>setFirChoice(event.target.value)}
                        >              
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Garden City'}>{'Garden City'}</MenuItem>
                            <MenuItem value={'McKinney'}>{'McKinney'}</MenuItem>
                            <MenuItem value={'Steves'}>{'Steves'}</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs>
                        <InputLabel htmlFor="mont-helper">Second Choice</InputLabel>
                        <Select
                            value={secondChoice}
                            className={classes.FulltextField}
                            onChange={event=>setSecondChoice(event.target.value)}
                        >              
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Garden City'}>{'Garden City'}</MenuItem>
                            <MenuItem value={'McKinney'}>{'McKinney'}</MenuItem>
                            <MenuItem value={'Steves'}>{'Steves'}</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs>
                        <InputLabel htmlFor="mont-helper">Third Choice</InputLabel>
                        <Select
                            value={thirdChoice}
                            className={classes.FulltextField}
                            onChange={event=>setThirdChoice(event.target.value)}
                        >              
                            <MenuItem value={''}>{'Please select..'}</MenuItem> 
                            <MenuItem value={'Garden City'}>{'Garden City'}</MenuItem>
                            <MenuItem value={'McKinney'}>{'McKinney'}</MenuItem>
                            <MenuItem value={'Steves'}>{'Steves'}</MenuItem>
                        </Select>
                    </Grid>
                </Grid>             
            </>
            );           
        }
    }
    
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <h1 className='Title2-settings'>Please select up to {program === "LFI" ? "(2)" : "(3)"} school to apply</h1>
            <SelectionBasedOnProgram />
        </>
    );
}